import React, { memo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'jquery/dist/jquery.min.js';
import $ from 'jquery';
import '../../index.css';
import { getReportContent } from '../../API/report';
import '../../Styles/Reports/displayReportData.css';
import { Accordion } from 'react-bootstrap';
import { USERAGLCLICK } from '../../AppTextConstants';
import { clusterBy } from "../../Utils/helpers";
//import {getPositionCategory} from '../../API/parser';
//import {clusterBy} from '../../Utils/helpers';


class DisplayDetailsComponent extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            detailData: [], projectName: ''
        };
        this.setAGLs = this.setAGLs.bind(this);
        this.removeAGLs = this.removeAGLs.bind(this);

    }

    setAGLs(o) {
        let temp = [];
        let individualContent = [];

        if (this.props.type === 'Hinweis') {
            temp = this.props.hinweisSelectedAGLs;
            individualContent = this.props.hinweisIndividualContent;
        } else if (this.props.type === 'Potenzial') {
            temp = this.props.potenzialSelectedAGLs;
            individualContent = this.props.potenzialIndividualContent;
        } else if (this.props.type === 'Risiko') {
            temp = this.props.risikoSelectedAGLs;
            individualContent = this.props.risikoIndividualContent;
        }
        if (typeof o === 'object') {
            individualContent.push(o);
        } else {
            temp.push(o);
        }

        if (this.props.type === 'Hinweis') {
            this.props.setHinweisSelectedAGLs(temp);
            this.props.setHinweisIndividualContent(individualContent);
        } else if (this.props.type === 'Potenzial') {
            this.props.setPotenzialSelectedAGLs(temp);
            this.props.setPotenzialIndividualContent(individualContent);
        } else if (this.props.type === 'Risiko') {
            this.props.setRisikoSelectedAGLs(temp);
            this.props.setRisikoIndividualContent(individualContent);
        }

        this.props.setIsIndividualPDFActive(true);
    }

    removeAGLs(o) {
        let temp = [];
        let individualContent = [];

        if (this.props.type === 'Hinweis') {
            temp = this.props.hinweisSelectedAGLs;
            individualContent = this.props.hinweisIndividualContent;
        } else if (this.props.type === 'Potenzial') {
            temp = this.props.potenzialSelectedAGLs;
            individualContent = this.props.potenzialIndividualContent;
        } else if (this.props.type === 'Risiko') {
            temp = this.props.risikoSelectedAGLs;
            individualContent = this.props.risikoIndividualContent;
        }
        if (typeof o === 'object') {
            let index = individualContent.indexOf(o);
            temp.splice(index, 1);
        } else {
            let removeIndex = temp.indexOf(o);
            temp.splice(removeIndex, 1);
        }

        if (this.props.type === 'Hinweis') {
            this.props.setHinweisSelectedAGLs(temp);
            this.props.setHinweisIndividualContent(individualContent);
        } else if (this.props.type === 'Potenzial') {
            this.props.setPotenzialSelectedAGLs(temp);
            this.props.setPotenzialIndividualContent(individualContent);
        } else if (this.props.type === 'Risiko') {
            this.props.setRisikoSelectedAGLs(temp);
            this.props.setRisikoIndividualContent(individualContent);
        }
    }

    async componentDidMount() {
        const dType = this.props.detailType; // Example: 'Hinweis'

        let originalLVID = this.props.theLVID;

        console.log(originalLVID)
        // let dashedLVID = '';
        // if (!originalLVID.includes('-')) {
        // 	dashedLVID =
        // 		originalLVID.slice(0, 8) +
        // 		'-' +
        // 		originalLVID.slice(8, 12) +
        // 		'-' +
        // 		originalLVID.slice(12, 16) +
        // 		'-' +
        // 		originalLVID.slice(16, 20) +
        // 		'-' +
        // 		originalLVID.slice(20);
        // } else {
        // 	dashedLVID = originalLVID;
        // }
        let clusteredPositionCategory = ""

        //const positionCategoryData = await getPositionCategory(dashedLVID);
        let positionCategoryData = this.props.pageData.lvInfo
        //const positionCategoryData = []

        // Editted by kingsley
        // if (positionCategoryData !== []) {
        //     clusteredPositionCategory = clusterBy(positionCategoryData.data.OZ, 'category')

        // }
        //if (positionCategoryData?.length === 0) {
        //re-edit by abhi
        if (positionCategoryData!== []) {
            clusteredPositionCategory = clusterBy(positionCategoryData.data.OZ, 'category')
        }


        let hinweisAGLs = this.props.hinweisSelectedAGLs;
        let potenzialAGLs = this.props.potenzialSelectedAGLs;
        let risikoAGLs = this.props.risikoSelectedAGLs;

        let hinweisUIDs = this.props.hinweisIndividualContent;
        let potenzialUIDs = this.props.potenzialIndividualContent;
        let risikoUIDs = this.props.risikoIndividualContent;

        let params = {
            modalData: {
                lvInfo: this.props.lvInfo,
                annotationData: this.props.annotationData
            },

            content: this.props.content,
            dType: dType,
            setAGLs: this.setAGLs,
            removeAGLs: this.removeAGLs,
            hinweisAGLs: hinweisAGLs,
            potenzialAGLs: potenzialAGLs,
            risikoAGLs: risikoAGLs,
            hinweisUIDs: hinweisUIDs,
            potenzialUIDs: potenzialUIDs,
            risikoUIDs: risikoUIDs,
            positionCategoryData: clusteredPositionCategory,
            adviceCatalog: this.props.pageData.adviceCatalogData.response
        };


        const reportContentReceived = await getReportContent(params);
        this.setState({
            detailData: reportContentReceived, projectName: this.props.projectName
        });

        //Save content
        //let pathnameIdentifier = window.location.pathname;
        // let detailType = pathnameIdentifier.split('/')[3]
        // let lvID = pathnameIdentifier.split('/')[2]
        /*let data = await getReportDetail(lvID, detailType);


        if (dType === 'Hinweis') {
            this.props.setHinweisContent(data.response);
        } else if (dType === 'Potenzial') {
            this.props.setPotenzialContent(data.response);
        } else if (dType === 'Risiko') {
            this.props.setRisikoContent(data.response);
        }*/

        // Datatable initialisation
        $('.webReportTableSecond')
            .DataTable({
                dom: 'frtilp',
                language: {
                    fontcolor: 'white', url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
                },
                bPaginate: false,
                bFilter: false,
                bInfo: false,
                order: [[5, 'asc']],
                columnDefs: [
                    {
                        "targets": 'sort',
                        "orderable": true,
                    },
                    {
                        targets: 5, // Assuming the 'menge' column has the class 'menge'
                        type: 'num-fmt' // Ensure numeric sorting for the 'menge' column
                    }
                ]
            });

    }

    render() {
        return (
            <div className="detailsTableContainer">
                <h3 className="detailsTableProjectName">LV-Analyse: {this.state.projectName}</h3>
                <br />

                <p className="handwai-text-label-normal">{USERAGLCLICK}</p>
                <Accordion className="add1200Width" defaultActiveKey="0">
                    {this.state.detailData}
                </Accordion>
            </div>);
    }
}

export default memo(DisplayDetailsComponent);










/*
import React, {memo} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'jquery/dist/jquery.min.js';
import $ from 'jquery';
import '../../index.css';
import {getReportContent} from '../../API/report';
import '../../Styles/Reports/displayReportData.css';
import {Accordion} from 'react-bootstrap';
import {USERAGLCLICK} from '../../AppTextConstants';
import {clusterBy} from "../../Utils/helpers";
//import {getPositionCategory} from '../../API/parser';
//import {clusterBy} from '../../Utils/helpers';

class DisplayDetailsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            detailData: [], projectName: ''
        };
        this.setAGLs = this.setAGLs.bind(this);
        this.removeAGLs = this.removeAGLs.bind(this);
    }

    setAGLs(o) {
        let temp = [];
        let individualContent = [];

        if (this.props.type === 'Hinweis') {
            temp = this.props.hinweisSelectedAGLs;
            individualContent = this.props.hinweisIndividualContent;
        } else if (this.props.type === 'Potenzial') {
            temp = this.props.potenzialSelectedAGLs;
            individualContent = this.props.potenzialIndividualContent;
        } else if (this.props.type === 'Risiko') {
            temp = this.props.risikoSelectedAGLs;
            individualContent = this.props.risikoIndividualContent;
        }
        if (typeof o === 'object') {
            individualContent.push(o);
        } else {
            temp.push(o);
        }

        if (this.props.type === 'Hinweis') {
            this.props.setHinweisSelectedAGLs(temp);
            this.props.setHinweisIndividualContent(individualContent);
        } else if (this.props.type === 'Potenzial') {
            this.props.setPotenzialSelectedAGLs(temp);
            this.props.setPotenzialIndividualContent(individualContent);
        } else if (this.props.type === 'Risiko') {
            this.props.setRisikoSelectedAGLs(temp);
            this.props.setRisikoIndividualContent(individualContent);
        }

        this.props.setIsIndividualPDFActive(true);
    }

    removeAGLs(o) {
        let temp = [];
        let individualContent = [];

        if (this.props.type === 'Hinweis') {
            temp = this.props.hinweisSelectedAGLs;
            individualContent = this.props.hinweisIndividualContent;
        } else if (this.props.type === 'Potenzial') {
            temp = this.props.potenzialSelectedAGLs;
            individualContent = this.props.potenzialIndividualContent;
        } else if (this.props.type === 'Risiko') {
            temp = this.props.risikoSelectedAGLs;
            individualContent = this.props.risikoIndividualContent;
        }
        if (typeof o === 'object') {
            let index = individualContent.indexOf(o);
            temp.splice(index, 1);
        } else {
            let removeIndex = temp.indexOf(o);
            temp.splice(removeIndex, 1);
        }

        if (this.props.type === 'Hinweis') {
            this.props.setHinweisSelectedAGLs(temp);
            this.props.setHinweisIndividualContent(individualContent);
        } else if (this.props.type === 'Potenzial') {
            this.props.setPotenzialSelectedAGLs(temp);
            this.props.setPotenzialIndividualContent(individualContent);
        } else if (this.props.type === 'Risiko') {
            this.props.setRisikoSelectedAGLs(temp);
            this.props.setRisikoIndividualContent(individualContent);
        }
    }

    async componentDidMount() {
        const dType = this.props.detailType; // Example: 'Hinweis'

        let originalLVID = this.props.theLVID;

        console.log(originalLVID)
        // let dashedLVID = '';
        // if (!originalLVID.includes('-')) {
        // 	dashedLVID =
        // 		originalLVID.slice(0, 8) +
        // 		'-' +
        // 		originalLVID.slice(8, 12) +
        // 		'-' +
        // 		originalLVID.slice(12, 16) +
        // 		'-' +
        // 		originalLVID.slice(16, 20) +
        // 		'-' +
        // 		originalLVID.slice(20);
        // } else {
        // 	dashedLVID = originalLVID;
        // }
        let clusteredPositionCategory = ""

        //const positionCategoryData = await getPositionCategory(dashedLVID);
        let positionCategoryData = this.props.pageData.lvInfo
        //const positionCategoryData = []
        if (positionCategoryData !== []) {
            clusteredPositionCategory = clusterBy(positionCategoryData.data.OZ, 'category')
        }


        let hinweisAGLs = this.props.hinweisSelectedAGLs;
        let potenzialAGLs = this.props.potenzialSelectedAGLs;
        let risikoAGLs = this.props.risikoSelectedAGLs;

        let hinweisUIDs = this.props.hinweisIndividualContent;
        let potenzialUIDs = this.props.potenzialIndividualContent;
        let risikoUIDs = this.props.risikoIndividualContent;

        let params = {
            content: this.props.content,
            dType: dType,
            setAGLs: this.setAGLs,
            removeAGLs: this.removeAGLs,
            hinweisAGLs: hinweisAGLs,
            potenzialAGLs: potenzialAGLs,
            risikoAGLs: risikoAGLs,
            hinweisUIDs: hinweisUIDs,
            potenzialUIDs: potenzialUIDs,
            risikoUIDs: risikoUIDs,
            positionCategoryData: clusteredPositionCategory,
            adviceCatalog: this.props.pageData.adviceCatalogData.response
        };


        const reportContentReceived = await getReportContent(params);
        this.setState({
            detailData: reportContentReceived, projectName: this.props.projectName
        });

        //Save content
        //let pathnameIdentifier = window.location.pathname;
        // let detailType = pathnameIdentifier.split('/')[3]
        // let lvID = pathnameIdentifier.split('/')[2]
        /!*let data = await getReportDetail(lvID, detailType);


        if (dType === 'Hinweis') {
            this.props.setHinweisContent(data.response);
        } else if (dType === 'Potenzial') {
            this.props.setPotenzialContent(data.response);
        } else if (dType === 'Risiko') {
            this.props.setRisikoContent(data.response);
        }*!/

        // Datatable initialisation
        $('.webReportTable')
            .DataTable({
                dom: 'frtilp', language: {
                    fontcolor: 'white', url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
                }, bPaginate: false, bFilter: false, bInfo: false, order: [], columnDefs: [{
                    "targets": 'no-sort', "orderable": false,
                }]
            });

    }

    render() {
        return (<div className="detailsTableContainer">
            <h3 className="detailsTableProjectName">LV-Analyse: {this.state.projectName}</h3>
            <br/>

            <p className="handwai-text-label-normal">{USERAGLCLICK}</p>
            <Accordion className="add1200Width" defaultActiveKey="0">
                {this.state.detailData}
            </Accordion>
        </div>);
    }
}

export default memo(DisplayDetailsComponent);
*/
